module.exports = __webpack_public_path__ + "img/favicon.8d31215e.png";